import { Crown, User } from 'lucide-react'
import type { OrgChartRenderNodeArgs } from '@tatatemplate/shared-lib/org-chart-canvas'
import { isKepalaDesa } from '@tatatemplate/shared-lib'

export function ChartNodeCard({ node, showFoto, showPeriode }: OrgChartRenderNodeArgs) {
  const isKepala = isKepalaDesa(node.namaJabatan)
  const accent = node.nodeColor ?? (isKepala ? '#1d4ed8' : '#0891b2')
  return (
    <div
      className="w-full h-full rounded-lg border border-slate-200 bg-white shadow-sm flex flex-col items-center justify-center px-3 py-2 text-center"
      style={{ borderTopWidth: 2, borderTopColor: accent }}
    >
      {showFoto && (
        node.imagePejabat
          ? <img src={node.imagePejabat} alt={node.namaPejabat ?? ''} className="w-10 h-10 rounded-full object-cover mb-1" />
          : <span className="w-10 h-10 rounded-full mb-1 flex items-center justify-center" style={{ background: `${accent}1a`, color: accent }}>
              {isKepala ? <Crown size={18} /> : <User size={18} />}
            </span>
      )}
      <div className="text-[11px] font-semibold leading-tight" style={{ color: accent }}>{node.namaJabatan ?? '—'}</div>
      <div className="text-xs font-medium text-slate-700 leading-tight">{node.namaPejabat ?? '-'}</div>
      {showPeriode && node.periodePejabat && (
        <div className="text-[10px] text-slate-400 mt-0.5">{node.periodePejabat}</div>
      )}
    </div>
  )
}
